import { render, staticRenderFns } from "./Masterpieces.vue?vue&type=template&id=64196baa"
import script from "./Masterpieces.vue?vue&type=script&lang=js"
export * from "./Masterpieces.vue?vue&type=script&lang=js"
import style0 from "./Masterpieces.vue?vue&type=style&index=0&id=64196baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports